import { css, Grid, styled, Typography } from '@mui/material';
import { colors } from 'theme/colors';

export const AccessoryInformationTitle = styled(Typography)`
  padding: 8px 0px 10px 0px;
  text-transform: uppercase;
  color: ${colors.primary500};
  font-weight: 600;
  line-height: 24px;
  letter-spacing: 0.02em;
`;

interface IAccessoryInformationContainer {
  borderHidden?: boolean;
}
export const AccessoryInformationContainer = styled(Grid)`
  border-bottom: 1px solid ${colors.primary25};
  padding-bottom: 15px;
  row-gap: 18px;
  ${(props: IAccessoryInformationContainer) =>
    props?.borderHidden &&
    css`
      border: none;
      padding-bottom: 0;
    `}
`;
